import React, { ReactNode } from 'react'
import Link from 'next/link'
import styled from '@emotion/styled'
import { colors } from 'parameters/ui'
import { UrlObject } from 'url'
import { ifHovered } from 'components/styles'
import { ColorMods } from 'components/styles/primitives/modifiers/text/colorMods'
import { TextMods } from 'components/styles/primitives/modifiers/text/textMods'
import { css } from '@emotion/react'

interface Props {
	href: UrlObject | string
	children: string | ReactNode
}

export const StyledA = ({ href, children }: Props) => (
	<Link href={href} passHref legacyBehavior>
		<StyledAnchor>{children}</StyledAnchor>
	</Link>
)

export const StyledAnchor = styled.a([
	ColorMods({ color: colors.primaryPurple1 }),
	ifHovered(css({ color: colors.secondaryPurple1 })),
	TextMods.NoDecoration
])
